import { useEffect, useState } from 'react';
import { IMAGE_ORIENTATION_CACHE } from '../utils/variables';

export const ORIENTATION = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
  UNKNOWN: 'UNKNOWN',
};

export default function useImageOrientation(url) {
  const [data, setData] = useState({});

  useEffect(() => {
    if (!url) return;

    if (IMAGE_ORIENTATION_CACHE[url]) {
      setData(IMAGE_ORIENTATION_CACHE[url]);
      return;
    }

    const img = new Image();

    img.onload = () => {
      const { height, width } = img;

      // >= : squares count as portrait — keep in sync with useImageOrientations.
      const orientation = height >= width ? ORIENTATION.PORTRAIT : ORIENTATION.LANDSCAPE;

      IMAGE_ORIENTATION_CACHE[url] = { height, orientation, width };
      setData({ height, orientation, width });
    };

    img.src = url;
  }, [url]);

  return data;
}
